import { Component } from 'react';
import { UniGrid } from '../UniGrid';

class ComplexInputField extends Component {
    state = {
        row: this.props.row ?? {},
        data: this.props.data ?? { /*baseUrl: '',*/ table: '', row: {}, rows: [] },
        value: this.props.value,
        type: this.props.type,

    }

    // (base)row, its columns or fields =>
    // type => this.props.type: {children or relateds} UniGrid or tabs containing unigrids, (Sub)Form, MultiSelectGrid, List
    // onValueChanged, loadApi, saveApi =>
    // readOnly, visible

    render() {
        let type = this.state.type ?? '';
        let { /*baseUrl,*/ table, row, rows } = this.state.data ?? {};

        return <div style={{ padding: '3rem 1rem', background: '#ccc', width: '100%' }}>در حال کدنویسی...</div>

        if (type === 'grid')
            return (
                <UniGrid table={table} rows={rows}
                />
            );

        if (type === 'multi-select')
            return (
                <UniGrid table={table} rows={rows}
                />
            );

        if (type === 'form')
            return (
                <></>
            );

        if (type === 'single-select')
            return (
                <></>
            );

    }
}

export default ComplexInputField; 